import { useState } from "react";
import { TabsStore } from "src/lib/tabs-ui/TabsStore.tsx";
import { Skeleton } from "src/components/Skeleton/Skeleton.tsx";
import { Tabs } from "src/components/Tabs/Tabs.tsx";

export const ModuleLayoutMockTabs = () => {
  const [mockStore] = useState(() => {
    const store = new TabsStore();
    store.prependTabs([
      {
        id: "some-path",
        title: <Skeleton isLoading={true}>All products</Skeleton>,
        content: <div></div>,
      },
      ...new Array(5).fill(null).map((item, index) => ({
        id: `some-path-${index}`,
        title: <Skeleton isLoading={true}>dfdfd-fdfadf3-4343</Skeleton>,
        content: <div></div>,
      })),
    ]);
    store.tabs[1].activate();
    return store;
  });
  return (
    <Tabs
      store={mockStore}
      hidePlusButton={true}
      plusButtonHelperText="Create new item"
    />
  );
};
